module.exports = __webpack_public_path__ + "img/_ABS9809(1).95b898eb.jpg";